// src/components/LegalCard.jsx
import React from 'react';

const LegalCard = ({ icon, title, description, link }) => {
  return (
    <div className="card">
      <div className="icon">{icon}</div>
      <h3>{title}</h3>
      <p>{description}</p>
      
    </div>
  );
};

export default LegalCard;


